import { Box, styled, Typography } from '@mui/material';

import { colors } from '../../../../theme';

export const ItemContainer = styled(Box)`
    background-color: ${colors.darkGray};
    border-radius: 6px;
    padding: 10px 12px;
`;

export const ItemHeader = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
`;

export const ItemTitle = styled(Typography)`
    font: 600 13px 'Inter';
    color: ${colors.white90};
`;

export const Caret = styled('span')`
    font-size: 14px;
    color: ${colors.white50};
    user-select: none;
`;

export const LatestBadge = styled(Box)`
    display: inline-block;
    padding: 2px 6px;
    border-radius: 8px;
    font: 600 10px 'Inter';
    color: ${colors.lightningYellow};
    background-color: ${colors.lightningYellowRgba2};
    margin-left: 8px;
`;
